import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { Colors } from "./colors.js";
const hillFilePath = "/blender/hills.glb";
const loader = new GLTFLoader();

// Simple solid white material to avoid texture loading
const grassMaterial = new THREE.MeshStandardMaterial({
  color: Colors.green,
  roughness: 0.9,
  metalness: 0,
  side: THREE.DoubleSide,
});

let hillObjects = {};

// Load hills
loader.load(hillFilePath, (gltf) => {
  gltf.scene.scale.set(2);
  gltf.scene.traverse((obj) => {
    if (!obj.isMesh) return;

    const proto = obj.clone(true);
    proto.material = null; // remove old material
    hillObjects[obj.name] = proto;
  });
});

export class Hill extends THREE.Object3D {
  constructor(loop, x, z, y = 0, hillName = "hill2") {
    super();
    const wait = setInterval(() => {
      const src = hillObjects[hillName];
      if (!src) return;

      // Clone hill mesh
      const mesh = src.clone(true);

      // Assign grass material
      mesh.material = grassMaterial.clone();

      this.add(mesh);
      clearInterval(wait);
    }, 16);

    this.position.set(x, y, z);
    this.targetStretch = 1;
    this.currentStretch = 1;
    this.heightOffsetScale = 0.8;
    this.baseUp = new THREE.Vector3(0, 1, 0);
    loop.updatables.push(this);
  }

  setNormal(normal) {
    if (!normal) return;
    const n = normal.clone().normalize();
    this.quaternion.setFromUnitVectors(this.baseUp, n);
  }

  stretch(amount) {
    this.targetStretch = amount;
  }

  getHeightOffsetForStretch(stretch) {
    return (stretch - 1) * this.heightOffsetScale;
  }

  tick(delta) {
    this.currentStretch += (this.targetStretch - this.currentStretch) * 0.1;
    this.scale.y = this.currentStretch;
  }
}
